import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.supplementSettings;
export const userSupplementSettingsFormatsSelector = (state: RootState) =>
  getState(state).allowedFileExtensionsInquiryUpload;
export const userSupplementSettingsMaxFileSizeSelector = (state: RootState) =>
  getState(state).maxFileSizeInquiryUploadMb;
export const userSupplementSettingsErrorSelector = (state: RootState) => getState(state).error;
export const userSupplementSettingsIsLoadingSelector = (state: RootState) =>
  getState(state).isLoading;
export const userSupplementSettingsIsReadySelector = (state: RootState) => getState(state).isReady;
